// Vuex module for the Debug Dashboard.
// Caches per-panel snapshots so navigating away/back is instant.
// Pure UI state — no business logic.
export default {
  namespaced: true,

  state: {
    snapshots: {},          // { [panelKey]: { data, meta } }
    auditEntries: [],
    liveUpdatesEnabled: false, // global gate; panels poll only when this is true
  },

  mutations: {
    setSnapshot(state, { panel, payload }) {
      state.snapshots = { ...state.snapshots, [panel]: payload };
    },
    setAudit(state, entries) {
      state.auditEntries = entries;
    },
    setLiveUpdates(state, enabled) {
      state.liveUpdatesEnabled = !!enabled;
    },
  },

  getters: {
    snapshot: (state) => (panel) => state.snapshots[panel] || null,
    oldestAgeMs: (state) => {
      const ages = Object.values(state.snapshots)
        .map((s) => (s && s.meta && typeof s.meta.age_ms === 'number') ? s.meta.age_ms : 0);
      return ages.length ? Math.max.apply(null, ages) : 0;
    },
  },
};
